document.addEventListener('DOMContentLoaded', function () {
  // LP
  const registerBtns = document.querySelectorAll('.register_btn');
  const customSwatchTabs = document.querySelectorAll('.swatch-tab-btn');
  window.dataLayer = window.dataLayer || [];

  if (registerBtns.length) {
    registerBtns.forEach(btn => {
      btn.addEventListener('click', function (event) {
        let from = event.target.closest('.header') ? 'header' : 'hero_block';
        dataLayer.push({
          event: 'custom_event',
          event_name: 'register_now_button_click',
          parameter: JSON.stringify({
            from: from
          })
        });
      });
    });
  }

  function trackLoginClick(from) {
    dataLayer.push({
      event: 'custom_event',
      event_name: 'login_button_click',
      parameter: JSON.stringify({ from })
    });
  }

  const loginBtn = document.getElementById('loginBtn');
  if (loginBtn) {
    loginBtn.addEventListener('click', () => trackLoginClick('header'));
  }

  const loginLinks = document.querySelectorAll(
    '#b2b-hero-login-text p a, #b2b-login-text p a'
  );

  if (loginLinks.length) {
    loginLinks.forEach(link => {
      link.addEventListener('click', event => {
        const from = event.target.closest('.b2b_hero')
          ? 'hero_block'
          : 'register_form';
        trackLoginClick(from);
      });
    });
  }

  if (customSwatchTabs.length) {
    customSwatchTabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const currentSelected = document.querySelector(
          '.swatch-tab-btn.selected'
        );

        if (currentSelected === tab) return;

        dataLayer.push({
          event: 'custom_event',
          event_name: 'bestsellers_colour_change',
          parameter: JSON.stringify({
            from: document.querySelector('.swatch-tab-btn.selected').dataset
              .color,
            value: tab.dataset.color
          })
        });
      });
    });
  }

  // HP
  const shopNowButtons = document.querySelectorAll('.b2b_hero__shop-now');
  const reviewLinks = document.querySelectorAll('.b2b-review a');
  const spaceShineProdLinks = document.querySelectorAll(
    '.make-your-space-shine__link'
  );
  const quantityPdpButton = document.querySelector(
    '#quantity-increase-btn.quantity__button'
  );
  if (shopNowButtons.length) {
    shopNowButtons.forEach(btn => {
      btn.addEventListener('click', function (event) {
        const type = btn.classList.contains('sticky') ? 'sticky' : 'hero_block';

        dataLayer.push({
          event: 'custom_event',
          event_name: 'shop_now_button_click',
          parameter: JSON.stringify({
            type: type
          })
        });
      });
    });
  }

  if (reviewLinks.length) {
    reviewLinks.forEach(link => {
      link.addEventListener('click', function () {
        dataLayer.push({
          event: 'custom_event',
          event_name: 'comments_content_click',
          parameter: JSON.stringify({
            item_name: link.getAttribute('href').split('/').pop(),
            content_url: link.getAttribute('href')
          })
        });
      });
    });
  }
  if (spaceShineProdLinks.length) {
    spaceShineProdLinks.forEach(link => {
      link.addEventListener('click', function () {
        dataLayer.push({
          event: 'custom_event',
          event_name: 'make_your_space_shine_content_click',
          parameter: JSON.stringify({
            item_name: link.getAttribute('href').split('/').pop().split('?')[0],
            content_url: link.getAttribute('href')
          })
        });
      });
    });
  }
  if (quantityPdpButton) {
    let firstClick = true;
    quantityPdpButton.addEventListener('click', () => {
      if (firstClick) {
        dataLayer.push({
          event: 'custom_event',
          event_name: 'quantity_selector_click',
          parameter: ''
        });
        firstClick = false;
      }
    });
  }

  // registation events
  const formSection = document.querySelector('.wholesale-contact');
  if (!formSection) return;

  const fieldMap = {
    'ContactForm-first-name': 'register_now_typing_firstname',
    'ContactForm-last-name': 'register_now_typing_lastname',
    'ContactForm-email': 'register_now_typing_email',
    'ContactForm-company': 'register_now_typing_companyname',
    'ContactForm-web-address': 'register_now_typing_companywebsite'
  };
  const toggleCountry = formSection.querySelector('[data-country-toggle]');
  const submitBtn = formSection.querySelector('.contact__button .btn');

  Object.entries(fieldMap).forEach(([id, eventName]) => {
    const input = formSection.querySelector(`#${id}`);
    if (!input) return;

    const handler = () => {
      dataLayer.push({
        event: 'custom_event',
        event_name: eventName,
        parameter: ''
      });
      input.removeEventListener('input', handler);
    };

    input.addEventListener('input', handler);
  });

  if (toggleCountry) {
    toggleCountry.addEventListener(
      'click',
      e => {
        dataLayer.push({
          event: 'custom_event',
          event_name: 'register_now_select_country',
          parameter: ''
        });
      },
      { once: true }
    );
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', () => {
      dataLayer.push({
        event: 'custom_event',
        event_name: 'form_submitted',
        parameter: ''
      });
    });
  }
});
